/**************************************************************************************************/
/*   File: /src/app/shared/services/language/language.service.ts                                  */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { NGXLogger } from 'ngx-logger';
import { Observable, of, throwError } from 'rxjs';

import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { environment } from '../../../../environments/environment';
import { Messages } from '../../enums';
import { Language } from '../../models';

/**
 * The language service
 */
@Injectable({
    providedIn: 'root'
})
export class LanguageService {

    /**
     * The default language
     */
    defaultLanguage: string = environment.defaultLanguage;
    /**
     * The available languages
     */
    availableLanguages: string[] = environment.availableLanguages;

    /**
     * Contruct the service
     * @param translateService The translate service
     */
    constructor(private logger: NGXLogger, private translateService: TranslateService) {
    }


    /**
     * Initialize languages
     */
    public initializeLanguage(): Observable<Array<Language>> {

        const languageArray: Language[] = [];

        /**
         * Available languages is not defined
         */
        if (this.availableLanguages === undefined || this.availableLanguages.length === 0) {
            return throwError(Messages.CONFIGURATION_AVAILABLE_LANGUAGES);
        }
        /**
         * Create the array of available language
         */
        this.availableLanguages.forEach((langIso) => {
            this.logger.trace('Creating language for', langIso);
            const newLanguage = new Language(langIso);
            languageArray.push(newLanguage);
        });

        return of(languageArray);
    }

    /**
     * Check if isoCode is valid and in available languages.
     * Available languages is set in the environment
     * @param isoCode The isoCode 
     */
    public isValidLanguage(isoCode: string): Observable<boolean> {

        if (!isoCode) {
            return throwError(Messages.LANGUAGE_NOT_SET);
        }
      
        const availableLanguages = environment.availableLanguages;
        if (availableLanguages.indexOf(isoCode) < 0) {
            return throwError(Messages.NOT_VALID_LANGUAGE);
        }

        return of(true);

    }

    /**
     * Set the iso code for translate service
     * @param isoCode the isoCode
     */
    public setLanguage(isoCode: string): Observable<boolean> {
        this.translateService.setDefaultLang(this.defaultLanguage);
        this.translateService.use(isoCode);
        return of(true);
    }
}
